import { z } from 'zod';

import { makeEndpoint } from '../common';

const validDomainRegex = /^([a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?\.)+[a-zA-Z]{2,}$/;

export const validDomainSchema = z
  .string()
  .min(1, 'Domain is required')
  .regex(validDomainRegex, 'Please enter a valid domain');

const OrganizationDomainSchema = z.object({
  id: z.string().uuid(),
  organizationId: z.string().uuid(),
  domain: validDomainSchema,
  createdAt: z.string().datetime(),
  updatedAt: z.string().datetime(),
  deletedAt: z.string().datetime().nullable(),
});
export type OrganizationDomain = z.infer<typeof OrganizationDomainSchema>;

export const CreateOrganizationDomainRequestSchema = z
  .object({
    domain: validDomainSchema,
  })
  .strict();

export const GetOrganizationDomainsResponseSchema = z
  .object({
    items: z.array(OrganizationDomainSchema),
  })
  .strict();

export type GetOrganizationDomainsResponse = z.infer<typeof GetOrganizationDomainsResponseSchema>;

export const CreateOrganizationDomainEndpoint = makeEndpoint({
  method: 'POST',
  url: ({ organizationId }: { organizationId: string }) => `v1/organizations/${organizationId}/organization-domains`,
  responseSchema: z.void(),
  requestSchema: CreateOrganizationDomainRequestSchema,
});

export const GetOrganizationDomainsEndpoint = makeEndpoint({
  method: 'GET',
  url: ({ organizationId }: { organizationId: string }) => `v1/organizations/${organizationId}/organization-domains`,
  responseSchema: GetOrganizationDomainsResponseSchema,
  requestSchema: z.void(),
});

export const GetBrandDomainsEndpoint = makeEndpoint({
  method: 'GET',
  url: ({ brandId }: { brandId: string }) => `v1/brands/${brandId}/organization-domains`,
  responseSchema: GetOrganizationDomainsResponseSchema,
  requestSchema: z.void(),
});

export const DeleteOrganizationDomainEndpoint = makeEndpoint({
  method: 'DELETE',
  url: ({ organizationId, domainId }: { organizationId: string; domainId: string }) =>
    `v1/organizations/${organizationId}/organization-domains/${domainId}`,
  responseSchema: z.void(),
  requestSchema: z.void(),
});
